module.exports = __webpack_public_path__ + "img/protected-bag-icon-8.d75d4aa2.svg";